import { PRIMITIVE_TOOLS } from './tools';
import { MACROS } from './macros';
import type { AnyTool } from './tools/types';
import { clearAllHandles } from './refs';

const ALL_TOOLS: AnyTool[] = [...PRIMITIVE_TOOLS, ...MACROS];

const REGISTRY: Map<string, AnyTool> = new Map(ALL_TOOLS.map((t) => [t.name, t]));

export type DispatchOk = { ok: true; result: unknown };
export type DispatchErr = { ok: false; error: string };
export type DispatchOutcome = DispatchOk | DispatchErr;

export function listTools(): AnyTool[] {
  return ALL_TOOLS;
}

export function getTool(name: string): AnyTool | undefined {
  return REGISTRY.get(name);
}

export async function dispatchTool(name: string, input: unknown): Promise<DispatchOutcome> {
  const tool = REGISTRY.get(name);
  if (!tool) {
    console.warn(`[agent] unknown tool: ${name}`);
    return { ok: false, error: `Unknown tool: ${name}` };
  }
  try {
    const result = await tool.execute(input);
    return { ok: true, result };
  } catch (err) {
    const message = (err as Error).message ?? String(err);
    console.warn(`[agent] ${name} failed`, { input, error: message, err });
    return { ok: false, error: message };
  }
}

export function resetAgentState(): void {
  clearAllHandles();
}
